module.exports = __webpack_public_path__ + "static/media/login-visual-1.e6f11d15.svg";